<!--
 * @Author: hfxie
 * @Date: 2021-01-01 14:52:54
 * @LastEditors: haifeng_xie haifeng_xie@kingdee.com
 * @LastEditTime: 2024-03-28 16:56:22
 * @Description: 甘特图左侧结构树WBS
-->

<template>
    <!-- 任务行 -->
    <div
      class="wbs-info-box"
    >
      <template v-if="isVirtualMode">
        <VirtualList
          :listData="rowsShow"
          :positions="positions"
          :totalHeight="totalHeight"
          :estimatedItemSize="estimatedItemSize"
          v-slot="slotProps"
          @handleScroll="handleScroll"
          ref="vlist"
          :scrollTop="scrollTop"
        >
          <FormBodyCol
            :item="slotProps.item"
            :indRow="rowsShow.index"
            :colsShow="colsShow"
            :rowsShow="rowsShow"
            :rowsShowMap="rowsShowMap"
            :ganttType="ganttType"
            :estimatedItemSize="estimatedItemSize"
            :selectedArr="selectedArr"
          />
        </VirtualList>
      </template>
      <template v-else>
        <NomalList
          :listData="rowsShow"
          :totalHeight="totalHeight"
          :estimatedItemSize="estimatedItemSize"
          v-slot="slotProps"
          @handleScroll="handleScroll"
          ref="nlist"
          :scrollTop="scrollTop"
        >
          <FormBodyCol
            :item="slotProps.item"
            :indRow="rowsShow.index"
            :colsShow="colsShow"
            :rowsShow="rowsShow"
            :rowsShowMap="rowsShowMap"
            :ganttType="ganttType"
            :estimatedItemSize="estimatedItemSize"
            :selectedArr="selectedArr"
          />
        </NomalList>
      </template>

    </div>

</template>

<script>
import VirtualList from "../VirtualList";
import NomalList from "../NomalList";
import FormBodyCol from "./FormBodyCol";

export default {
  name: "FormBody",
  data() {
    return {
      /* 虚拟列表 */
      screenHeight: 0, // 可视区域高度
      positions: [],

      /* 定位 */
      preLocationItem: null,
      scrollTop: 0,

    };
  },
  inject: ["CONSTNAME"],
  props: {
    colsShow: {
      type: Array,
      default: () => { return []; },
    },
    rowsShow: {
      type: Array,
      default: () => { return []; },
    },
    rowsShowMap: {
      type: Object,
      default: () => { return null; },
    },
    // 滚动联动对象
    reactVueComponent: {
      type: Object,
      default: null,
    },
    reactVueIndex: {
      type: Number,
      default: 0,
    },
    ganttType: {
      type: String,
      default: "pageData",
    },
    estimatedItemSize: {
      type: Number,
      default: () => { return 50; },
    },
  },
  components: {
    VirtualList,
    NomalList,
    FormBodyCol,
  },
  computed: {
    getAuthentication() {
      return this.$utils.getAuthentication(this.$store.state.accessLevel, [1]);
    },
    // 列表总高度
    totalHeight() {
      return (this.rowsShowMap ? this.rowsShowMap.totalRow : this.rowsShow.length) * this.estimatedItemSize;
    },
    selectedArr() {
      const _selectedArr = this.$store.state[this.ganttType + "_selectedArr"];
      return _selectedArr;
    },
    // 虚拟滚动模式(数据量大于行阈值，非打印模式)
    isVirtualMode() {
      const flag = (
        this.rowsShow.length > this.$store.state.viewSchem.virtualStartNum && 
        !(this.$store.state.printStatus) &&
        !(this.$store.state.viewSchem.isPrintModeShow)
      );
      return flag;
    },
  },
  /*
    对行条目集合有增删的操作都必须先调用 $store.commit("set_noUpdatePosition", true);才能使之更新
  */
  watch: {
    "rowsShow": {
      handler(newVal, oldVal) {
        if(!this.isVirtualMode) return;
        if (this.$store.state[this.ganttType + "_noUpdatePosition"]) return;
        this.initPositions();
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    initPositions() {
      const posArr = [];
      if (this.rowsShow.length > 0) {
        // this.screenHeight = this.$el.clientHeight;
        for (let index = 0; index < this.rowsShow.length; index++) {
          const item = this.rowsShow[index];
          const flag = this.rowsShowMap && this.rowsShowMap[item.id];
          const info = {
            index,
            id: item.id,
            height: this.estimatedItemSize * (flag ? this.rowsShowMap[item.id].rowCount : 1),
            top: this.estimatedItemSize * (flag ? this.rowsShowMap[item.id].startRow - 1 : index),
            bottom: (flag ? (this.rowsShowMap[item.id].rowCount + this.rowsShowMap[item.id].startRow - 1) : (index + 1)) * this.estimatedItemSize,
          };
          posArr.push(info);
        }
        this.positions = posArr;
        this.$store.commit("set_noUpdatePosition", { status: false, ganttType: this.ganttType });
      }
    },
    // 滚动事件
    handleScroll(info) {
      const _self = this;
      const { scrollTop } = info; // , start, end
      if (_self.$store.state.showMode == "both") {
        info.ganttType = this.ganttType;
        const _reactVueComponent = this.reactVueComponent;
        if (
          _reactVueComponent != null &&
          _reactVueComponent.$el != null
        ) {
          _reactVueComponent.$el.scrollTop = scrollTop;
          if(this.isVirtualMode){
            this.$emit("setStartEnd", info);
          }
        } else {
          // console.log("无绑定联动组件值·F");
          const targetEl = _self.$el.parentNode.parentNode.parentNode.parentNode.getElementsByClassName(
            "gantt-content",
          )[_self.reactVueIndex];
          targetEl.scrollTop = scrollTop;
        }
      }
      this.scrollTop = scrollTop;

    },
    /* handleScrollNomal(info) {
      const _self = this;
      // console.log("常规滚动", info);
      if (_self.$store.state.showMode == "both") {
        const { scrollTop } = info;
        info.ganttType = this.ganttType;
        const _reactVueComponent = this.reactVueComponent;
        if (
          _reactVueComponent != null &&
          _reactVueComponent.$el != null
        ) {
          _reactVueComponent.$el.scrollTop = scrollTop;
        } else {
          // console.log("无绑定联动组件值·F");
          const targetEl = _self.$el.parentNode.parentNode.parentNode.parentNode.getElementsByClassName(
            "gantt-content",
          )[_self.reactVueIndex];
          targetEl.scrollTop = scrollTop;
        }
        this.scrollTop = scrollTop;
      }
    }, */
  },
};
</script>

<style scoped lang='less'>
@import './FormBody.less';
</style>
